export default class LoginData {
    email = ''
    password = ''
}
